import {FormikProps} from "formik";
import {useEffect, useRef} from "react";
import {useNotifications} from "../../../context/NotificationContext";

export function ErrorNotification({ formik } : { formik: FormikProps<any> }) {
  const prevSubmitCount = useRef(formik.submitCount);
  const {notify} = useNotifications();

  useEffect(() => {
    // Only run when submitCount increments
    if (formik.submitCount > prevSubmitCount.current) {
      prevSubmitCount.current = formik.submitCount;

      if (!formik.isValid) {
        notify("error", `Failed to save`, 'Please check the form for errors and try again.', 5000)
      }
    }
  }, [formik.submitCount, formik.isValid, formik.errors, notify]);

  return null;
}